import React, { FC, ReactElement } from 'react'

export const SortingZA: FC = (): ReactElement => (
    <svg width='24px' height='24px' viewBox='0 0 32 32' enableBackground='new 0 0 32 32' xmlSpace='preserve'>
        <line
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            x1='23'
            y1='26.1'
            x2='23'
            y2='5'
        />
        <polyline
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            points='18.7,21.8 23,26.1 27.3,21.8 '
        />
        <polyline
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            points='12,27 12,26 9.1,18 8.9,18 6,26 6,27 '
        />
        <line fill='none' stroke='currentColor' strokeWidth='2' strokeMiterlimit='10' x1='6' y1='24' x2='12' y2='24' />
        <polyline
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            points='5,6 12,6 12,7 6,13 6,14 13,14 '
        />
    </svg>
)
